import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import "react-toastify/dist/ReactToastify.css";
import SummaryCards from "../../Components/LandlordPortal/Dashboard/SummaryCards";
import axios from "axios";
import Config from "../../Config";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-query";
import {
    DashboardSkeleton,
} from "../../Components/SkeletonLoading";
import QuickAction from "../../Components/LandlordPortal/Dashboard/QuickAction";
import Tables from "../../Components/LandlordPortal/Dashboard/Tables";
import DuesSummary from "../../Components/LandlordPortal/Dashboard/DuesSummary";
import CollectionSummary from "../../Components/LandlordPortal/Dashboard/CollectionSummary";
import moment from "moment";
import { toast } from "react-toastify";
import NotFoundModel from "../../Components/NotFoundModel";
import { Save_Property } from "../../Redux/actions";

const LandlordDashboard = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.UserReducer.user);
    const [apiData, setApiData] = useState();
    const [recentTransaction, setRecentTransaction] = useState();
    const [duesStats, setDuesStats] = useState();
    const [collectionStats, setCollectionStats] = useState();

    const [startDate, setStartDate] = useState(
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment().endOf("month").format("YYYY-MM-DD")
    );

    const fetchFunction = async () => {
        const query = `&startDate=${startDate}&endDate=${endDate}`;
        const response = await axios.get(
            `${Config.apiUrl}/landlord/dashboard?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: (res) => {
            if (res.isSuccess === false) {
                const errorMessage = res.message || "Request failed";
                toast.error(errorMessage);
                setApiData(null);
                setRecentTransaction([]);
                setDuesStats(null);
                setCollectionStats(null);
            } else {
                setApiData(res);
                setRecentTransaction(res?.latestTransactions || []);
                setDuesStats(res?.dueStats || null);
                setCollectionStats(res?.collectionStats || null);
                if (res?.properties) {
                    const allProperty = {
                        id: 0,
                        name: "All Properties",
                        gId: "KIPINN",
                        type: 0,
                        tenantPreference: 3,
                        tenantCount: 0,
                        occupiedBedCount: 0,
                        bedCount: 0,
                    };
                    const propertiesWithAll = [allProperty, ...res?.properties];
                    dispatch(Save_Property(propertiesWithAll));
                }
            }
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message ||
                error.message ||
                "Network error occurred";
            toast.error(errorMessage);
            setApiData(null);
            setRecentTransaction([]);
            setDuesStats(null);
            setCollectionStats(null);
        },
    });

    useEffect(() => {
        if (!startDate || !endDate) return;

        const handler = setTimeout(() => {
            getListMutate();
        }, 50);

        return () => clearTimeout(handler);
    }, [startDate, endDate, getListMutate]);

    return (
        <Container>
            {(isLoading || isRefetching) && <DashboardSkeleton />}

            {!error && !isLoading && apiData && (
                <>
                    <Card>
                        <SummaryCards
                            apiData={apiData}
                        />
                    </Card>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-6 md:gap-0 md:space-x-6 mt-6">
                        <CollectionSummary
                            collectionStats={collectionStats}
                        />
                        <DuesSummary
                            duesStats={duesStats}
                        />
                    </div>

                    <div className="grid md:grid-cols-2 grid-cols-1 gap-6 md:gap-0 md:space-x-6 mt-6 pb-12">
                        <QuickAction />
                        <Tables
                            recentTransaction={recentTransaction}
                        />
                    </div>

                </>
            )
            }
            {error && !isLoading && <NotFoundModel />}
        </Container >
    );
};

const Container = tw.div`Container`;
const Card = tw.div`mt-2 md:mt-6 px-4 py-2 md:px-6 md:py-4 bg-white rounded-lg shadow-md`;
export default LandlordDashboard;
